import { AuthLayout, SuspenseLoader } from 'components';
import {
    Login,
    ForgotPassword,
    Verify,
    VerifyEmail,
    Register,
    ResetPassword,
} from 'pages/account';
import { NotFound } from 'pages/NotFound';
import React, { FC, lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { routes } from 'routes';

const Suspend = lazy(() => import('pages/suspend'));

const GuestRoutes: FC = () => {
    return (
        <Suspense fallback={<SuspenseLoader />}>
            <Switch>
                <Route
                    component={Suspend}
                    path={[routes.suspend.unsuspend, routes.suspend.suspend]}
                />

                <AuthLayout>
                    <Switch>
                        <Route component={Login} path={routes.login} />
                        <Route
                            component={ForgotPassword}
                            path={routes.forgotPassword}
                        />
                        <Route component={Verify} path={routes.verify} />
                        <Route
                            component={VerifyEmail}
                            path={routes.verifyEmail}
                        />
                        <Route
                            component={Register}
                            path={[
                                routes.register,
                                routes.registerWithReferralCode,
                            ]}
                        />
                        <Route
                            component={ResetPassword}
                            path={routes.resetPassword}
                        />
                        <Route component={NotFound} />
                    </Switch>
                </AuthLayout>
            </Switch>
        </Suspense>
    );
};

export default GuestRoutes;
